/* eslint-disable no-dupe-keys */
export default {
  settlement_rule: {
    name: '运营商结算规则',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '规则名称',
      note: '备注',
      settlement_period: '结算周期',
      settlement_days: '结算执行时间',
      sharing_type: 'ECMP渠道收费方式',
      power_sharing_price: '每度电分成 (元)',
      total_amount_sharing_rate: '按总价分成',
      service_amount_sharing_rate: '按服务费分成',
      free_sharing_power: '免分成电量额度 (度)',
      transaction_fee_rate: 'ECMP交易手续费率',
      service_provider: '运营商',
      begin_time: '生效时间',
      end_time: '结束时间',
      free_begin_time: '免费开始时间',
      free_end_time: '免费结束时间',
      time_range: '生效时间',
      free_time_range: '免分成时间',
      last_settled_at: '最近结算时间',
      priority: '优先级',
      status: '状态',
      filter_ev_charging_station_ids: '适用充电站',
      evcs_sharing_type: '第三方渠道收费方式',
      evcs_total_amount_sharing_rate: '总价优惠比例',
      evcs_service_amount_sharing_rate: '服务费优惠比例',
      evcs_transaction_fee_rate: '第三方交易手续费费率',
      created_at: '创建时间',
      updated_at: '更新时间',
      orders_amount: '结算订单总额',
      orders_count: '结算订单数量',
      orders_service_amount: '订单优惠后服务费',
      settled_at: '结算执行时间',
      idle_fee_tax_rate: '占位费税率',
      idle_fee_transaction_fee_rate: '占位费交易手续费率',
      charge_channel_id: '充电渠道'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      name: '规则名称',
      settlement_period: '结算周期',
      settlement_days: '结算执行时间',
      sharing_type: 'ECMP分成',
      total_amount_sharing_rate: '总费用分成费率',
      transaction_fee_rate: 'ECMP手续费率',
      service_provider_id: '运营商',
      begin_time: '生效时间',
      end_time: '结束时间',
      free_begin_time: '免费开始时间',
      free_end_time: '免费结束时间',
      valid_time_range: '生效时间',
      free_time_range: '免分成时间',
      last_settled_at: '最近结算时间',
      priority: '优先级',
      status: '状态',
      filter_ev_charging_station_ids: '适用站',
      filter_user_ids: '适用用户',
      user_id: '适用用户',
      filter_order_source_type: '适用订单类型',
      order_source_type: '订单来源',
      evcs_sharing_type: '第三方渠道收费方式',
      evcs_total_amount_sharing_rate: '第三方总价分成费率',
      evcs_service_amount_sharing_rate: '第三方服务费分成费率',
      evcs_transaction_fee_rate: '第三方手续费率',
      idle_fee_tax_rate: '占位费税率',
      idle_fee_transaction_fee_rate: '占位费交易手续费率',
      created_at: '创建时间',
      updated_at: '更新时间',
      charge_channel_id: '充电渠道',
      charge_station: '充电站',
      settlement_rule: '结算规则',
      settlement_discount: '渠道活动'
    },
    // Enum的属性
    settlement_periods: {
      daily: '按天结算',
      monthly: '按月结算'
    },
    sharing_types: {
      sharing_by_total_amount: '按总价(百分比分成)',
      sharing_by_service_amount: '按服务费(百分比分成)',
      sharing_by_consumed_power: '按电量(每度电分成)'
    },
    statuses: {
      enabled: '可用的',
      disabled: '禁用的'
    },
    virtual_statuses: {
      pending: '未生效',
      available: '生效中',
      expired: '已过期',
      disabled: '已禁用'
    },
    evcs_sharing_types: {
      sharing_by_total_amount: '按总价优惠',
      sharing_by_service_amount: '按服务费优惠'
    },
    order_source_types: {
      ecmp: '我方App订单',
      evcs: '第三方App订单'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询规则名称',
      select_filter_charge_channel: '选择充电渠道'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      ev_charging_station_settlements: '电站结算记录',
      order_settlements: '订单结算记录'
    },
    charge_channels: {
      name: '渠道名',
      user: '适用充电用户',
      order_source_type: '订单来源'
    },
    group_titles: {
      base: '基本信息/适用条件',
      time: '结算时间',
      charge_channel: '充电渠道',
      ecmp_sharing: 'ECMP渠道费',
      evcs_sharing: '第三方渠道费 (互联互通引流)',
      summary: '结算汇总',
      sharing_summary: '净收入结算汇总',
      evcs_summary: '互联互通结算汇总',
      ecmp_summary: 'ECMP结算汇总'
    },
    tips: {
      evcs_transaction_basing_on_evcs_sharing: '交易手续费 = 订单总额 x 交易手续费率',
      ecmp_sharing_basing_on_evcs_sharing: 'ECMP渠道费用 = 订单总额 x 渠道'
    },
    btn: {
      calc_preview: '订单结算计算',
      pre_calc_preview: '订单预结算'
    },
    validates: {
      whole_month_required: '按月结算的规则需要选择完整的月份'
    },
    titles: {
      export_charge_station_settlement_rule_statistics: '导出充电站结算规则汇总',
      export_settlement_rule_statistics_title: '充电站结算规则{0}月份汇总'
    },
    export_dialog: {
      statistics_date: '汇总月份',
      confirm_export: '确认导出'
    },
    list_tabs: {
      all: '全部规则',
      settlement_rule_statistics: '结算规则汇总'
    }
  }
}
